module.exports = __webpack_public_path__ + "static/img/dian.b8603099.png";